import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import csaUserDetailsReducer from './persistReducers/csaUserDetailsReducer';
// FEATURE DISABLED (Release july-2026)
// import activePersonaReducer from './persistReducers/activePersonaReducer';

const persistConfig = {
  key: 'root',
  storage,
};
let rootReducer = combineReducers({
  userActionData: csaUserDetailsReducer,
  // FEATURE DISABLED (Release july-2026)
  // activePersona: activePersonaReducer,
});
let persistedReducer = persistReducer(persistConfig, rootReducer);
export const persistDataStore = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});
persistStore(persistDataStore);

export default persistDataStore;
